import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import total from "../../images/status-up.png";

export default function TotalDepartment({ report }) {
  return <ReportCard src={total} title="Total Department" text={report} />;
}
